<template lang="pug">
.sv-map
    GmapMap.sv-map__map(
        :center="{ lat: 55.01960426023853, lng: 82.92459235560455 }"
        :zoom="12"
        :fullscreenControl="false"
        map-type-id="terrain"
        style="width: 100vw; height: 100vh"
        @click="choice"
    )
        GmapMarker(
            :position="position"
            :icon="require('@/assets/images/marker.png')"
        )

    FormCoordinates.sv-map__form(
        :coordinates="positionString"
        @confirm="confirm"
        @cancel="cancel"
    )
</template>

<script>
import FormCoordinates from '@/components/forms/FormCoordinates.vue';

export default {
  name: 'SvMap',

  components: {
    FormCoordinates,
  },

  data() {
    return {
      position: null,
    };
  },

  watch: {
    defaultPosition: {
      immediate: true,
      handler(val) {
        if (!val) return;
        this.position = {
          ...this.position,
          ...val,
        };
      },
    },
  },

  props: {
    defaultPosition: {
      type: Object,
      default: null,
    },
  },

  computed: {
    positionString() {
      if (!this.position) return '';
      return `${this.position.lat}, ${this.position.lng}`;
    },
  },

  methods: {
    choice(val) {
      this.position = {
        ...this.position,
        lat: val.latLng.lat(),
        lng: val.latLng.lng(),
      };
    },

    confirm() {
      this.$emit('input', this.position);
      this.$emit('confirm');
    },

    cancel() {
      this.position = this.defaultPosition;
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
.sv-map {
    width: 100vw;
    position: fixed;
    height: 100vh;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    z-index: 10;

    &__form {
        position: fixed;
        width: 430px;
        left: calc(50% - 215px);
        bottom: 60px;
    }
}
</style>
